function sessionName(formName, itemName) {
  return `${formName}:${itemName}`
}

function loadItemFromStorage(storage, formName, attr) {
  let item = storage.getItem(sessionName(formName, attr))
  if (!item) {
    return item
  }
  return JSON.parse(item)
}

function saveItemToStorage(storage, formName, itemName, value) {
  storage.setItem(sessionName(formName, itemName), JSON.stringify(value))
}

export function saveItem(formName, itemName, value) {
  saveItemToStorage(localStorage, formName, itemName, value)
}

export function loadForm(formName, ...attrs) {
  let storage = localStorage
  return function() {
    attrs.forEach(attr => {
      let item = loadItemFromStorage(storage, formName, attr)
      if (item != null) this[attr] = item
      else saveItem(formName, attr, this[attr])
      this.$watch(
        attr,
        function(val) {
          saveItem(formName, attr, val)
        },
        { deep: true },
      )
    })
  }
}

export function formItem(formName, attr) {
  return loadItemFromStorage(localStorage, formName, attr)
}

export function clearForm(formName) {
  for (let key in localStorage) {
    if (key.startsWith(formName)) localStorage.removeItem(key)
  }
}
